// Dummy key since we use the reverse proxy will handle the real key
export const DUMMY_STATSIG_SDK_KEY = 'client-000000000000000000000000000000000000000000'

export enum StatsigCustomAppValue {
  Mobile = 'mobile',
  Extension = 'extension',
}
